import React from 'react';
import ReactDOM from 'react-dom';

export default class TimeSheetLocationitem extends React.Component {
  constructor(props) {
    super(props);

    this._onClickHandler = this._onClickHandler.bind(this);
  }

  componentDidMount() {
    // because of popover click killer this click handler has to be set up on mount.
    ReactDOM.findDOMNode(this).onclick = e => this._onClickHandler(e);
  }

  _onClickHandler(e) {
    this.props.onLocationChange(this.props.location.id);
  }

  render() {
    const that = this;
    return (
      <li className={this.props.active ? 'active' : ''} onClick={this._onClickHandler}>
        {that.props.location.name}
      </li>
    );
  }
}
